import { ChainId, WETH9, ERC20Token } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  busd: new ERC20Token(
    ChainId.ETHEREUM,
    '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  dai: new ERC20Token(
    ChainId.ETHEREUM,
    '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://makerdao.com',
  ),
  nmx: new ERC20Token(
    ChainId.ETHEREUM,
    '0xE1ebCa67020162B87aCb7Ee758Ff9C7Aa8CC708c',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(ChainId.ETHEREUM, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD Coin'),
  usdt: new ERC20Token(
    ChainId.ETHEREUM,
    '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    6,
    'USDT',
    'Tether USD',
    'https://tether.to/',
  ),
  wbtc: new ERC20Token(ChainId.ETHEREUM, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC'),
  weth: WETH9[ChainId.ETHEREUM],
}
